import moment from "moment";
import { VerificationNames, DataVendors } from "shared/types";
import { CheckCircleBroken } from "untitledui-js-base";
import { getLogoSrc } from "../../../utils/getLogoSrc";

type ReportCompletedBannerProps = {
  completedAt: string;
  reportId: string;
  verificationName: VerificationNames;
  vendor?: DataVendors;
};

export const ReportCompletedBanner = ({
  completedAt,
  reportId,
  verificationName,
  vendor
}: ReportCompletedBannerProps) => {
  return (
    <div className="py-6">
      <div className="flex w-full justify-between items-center">
        <CheckCircleBroken className="text-content-100 h-6 w-6 mr-4" />
        <p className="text-sm text-content-1000 font-medium mr-auto">
          Report was successfully completed on{" "}
          {moment(completedAt).format("lll")}
        </p>
        {vendor ? (
          <img src={getLogoSrc(vendor)} alt={`Provider ${verificationName}`} />
        ) : getLogoSrc(verificationName) ? (
          <img
            src={getLogoSrc(verificationName)}
            alt={`Provider ${verificationName}`}
          />
        ) : null}
      </div>

      <p className="ml-10 text-content-300 text-xs font-medium">
        Report ID: {reportId}
      </p>

      {/* -mx-6 makes it wider than container */}
      <div className="-mx-6 mt-6 border-b border-alpha-40"></div>
    </div>
  );
};
